import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataGrid from 'react-data-grid';
import 'react-data-grid/lib/styles.css';
import '../App.css'

function Downloads(props){

    const [files,setFiles]=useState([])
    
    const downloadFile = async (row) => {
    try {

        const filename=row.filename
        
        const response = await axios.post(`/downloadfile`,{ filepath: row.filepath },
        {
            responseType: 'blob', // important for file downloads
        }
        );

        // Create a URL for the file blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error('Error downloading file:', error);
    }
    };

    const filesColDefs= [
        { key: 'index', name: 'No.',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'filename', name: 'File Name',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'country', name: 'Country',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'rowcount', name: 'Leads',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'creditsused', name: 'Credits Used',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'exporttype', name: 'Export Type',cellClass: 'cell-center', headerCellClass: 'cell-center'},
        { key: 'filepath', name: 'Download',cellClass: 'cell-center', headerCellClass: 'cell-center',
           formatter: ({ row }) => {

            return <div style={{ textAlign: 'center' }}><span onClick={()=>downloadFile(row)}><i class="bi bi-download"></i></span></div>;
            }
        }
    ];

    const defaultColumnOptions={
        resizable: true,
        width:'auto',
        cellClass: 'cell-center',
        headerCellClass: 'cell-center'
      }

    useEffect(()=>{
        axios.get(`/exportedfiles/${props.userid}`)
        .then(res => {
            const data=res.data.map((row,idx)=>{
                row.index=idx+1
                return row
            })
            setFiles(data);
        })
    },[])

    return (<>
        <div className="h-100">
            <div className='w-100 h-100 bg-white'>
                <DataGrid 
                    columns={filesColDefs} 
                    rows={files} 
                    // rowHeight={28} 
                    // headerRowHeight={32} 
                    className='h-100 w-100 rdg-light' 
                    defaultColumnOptions={defaultColumnOptions}
                />
            </div>

        </div>
    </>)
}

export default Downloads